import { I18n } from '@calendly/i18n';
import { AlertWarningCircleIcon, ArrowExpandIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { colorBgGrey1 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { capitalize } from 'lodash-es';
import { useMemo, forwardRef } from 'react';
const errorMessageWrapperCss = "e1t43huk";
const ErrorMessageWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(errorMessageWrapperCss, props.className)} />;
});
const messageWithIconCss = "m5p14s3";
const MessageWithIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(messageWithIconCss, props.className)} />;
});
export const StatusBanner = ({
  provider,
  isStripeConnected,
  isPaypalConnected
}) => {
  const statuses = useMemo(() => ({
    stripe: {
      isConnected: isStripeConnected
    },
    paypal: {
      isConnected: isPaypalConnected
    }
  }), [isPaypalConnected, isStripeConnected]);
  if (!provider || provider === 'none' || statuses[provider].isConnected) return null;
  return <ErrorMessageWrapper>
      <MessageWithIcon>
        <AlertWarningCircleIcon spacingRight={8} color={colorBgGrey1} />
        {I18n.t('publisher.event_types.payment_method.integration_disconnected_short', {
        provider: capitalize(provider)
      })}
      </MessageWithIcon>
      <MinimalButton as="a" fontSize="medium" href={`/integrations/${provider}`} target="_blank" rel="noopener noreferrer">
        <ArrowExpandIcon />
        {I18n.t('publisher.action.reconnect')}
      </MinimalButton>
    </ErrorMessageWrapper>;
};

require("./status_banner.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./status_banner.js");